module.exports = __webpack_public_path__ + "img/fi-rr-search-alt.8b26c35e.svg";